import { createContext } from 'react';
import { ModalTitle } from './types';

const ImportCandidateModalContext = createContext({
  isOpen: false,
  modalTitle: 'New Solution' as ModalTitle,
  solutionId: undefined as string | undefined,
  openModal: (): void => {
    // noop default context handler
  },
  closeModal: (): void => {
    // noop default context handler
  },
});

export default ImportCandidateModalContext;
